import grouped from './configs/grouped'
import stacked from './configs/stacked'
import column from './configs/column'
import line from './configs/line'
import hybrid from './configs/hybrid'
import horizontalStacked from './configs/horizontalStacked'
import stackedWithRanges from './configs/stackedWithRanges'
import horizontalGrouped from './configs/horizontalGrouped'
import pie from './configs/pie'
import bubble from './configs/bubble'
import stepLineWithSeriesRange from './configs/stepLineWithSeriesRange'
import map from './configs/map'
import treeMap from './configs/treeMap'

const AMCHART_GROUPED = 'AMCHART_GROUPED'
const AMCHART_STACKED = 'AMCHART_STACKED'
const AMCHART_HORIZONTAL_STACKED = 'AMCHART_HORIZONTAL_STACKED'
const AMCHART_HORIZONTAL_GROUPED = 'AMCHART_HORIZONTAL_GROUPED'
const AMCHART_STACKED_WITH_RANGES = 'AMCHART_STACKED_WITH_RANGES'
const AMCHART_COLUMN = 'AMCHART_COLUMN'
const AMCHART_LINE = 'AMCHART_LINE'
const AMCHART_HYBRID = 'AMCHART_HYBRID'
const AMCHART_PIE = 'AMCHART_PIE'
const AMCHART_BUBBLE = 'AMCHART_BUBBLE'
const AMCHART_STEP_LINE_WITH_SERIES_RANGE =
  'AMCHART_STEP_LINE_WITH_SERIES_RANGE'
const AMCHART_MAP = 'AMCHART_MAP'
const AMCHART_TREE_MAP = 'AMCHART_TREE_MAP'

export const configMap = {
  [AMCHART_GROUPED]: grouped,
  [AMCHART_STACKED]: stacked,
  [AMCHART_HORIZONTAL_STACKED]: horizontalStacked,
  [AMCHART_HORIZONTAL_GROUPED]: horizontalGrouped,
  [AMCHART_STACKED_WITH_RANGES]: stackedWithRanges,
  [AMCHART_COLUMN]: column,
  [AMCHART_LINE]: line,
  [AMCHART_HYBRID]: hybrid,
  [AMCHART_PIE]: pie,
  [AMCHART_BUBBLE]: bubble,
  [AMCHART_STEP_LINE_WITH_SERIES_RANGE]: stepLineWithSeriesRange,
  [AMCHART_MAP]: map,
  [AMCHART_TREE_MAP]: treeMap
}

export const AmChartTypes = {
  AMCHART_GROUPED,
  AMCHART_STACKED,
  AMCHART_COLUMN,
  AMCHART_LINE,
  AMCHART_HYBRID,
  AMCHART_HORIZONTAL_STACKED,
  AMCHART_HORIZONTAL_GROUPED,
  AMCHART_STACKED_WITH_RANGES,
  AMCHART_PIE,
  AMCHART_BUBBLE,
  AMCHART_STEP_LINE_WITH_SERIES_RANGE,
  AMCHART_MAP,
  AMCHART_TREE_MAP
}
